import React from 'react';
import Product from "components/partials/product";
import {Products} from "api";
import _HotProducts from './_HotProducts.scss';

class HotProducts extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: 10,
        order: "id DESC",
        where: {
          isIndustryFeatured: true
        }
      }
    };
    Products.actions.list.request(params).then(response => {
      if (response && response.data) {
        let products = this.state.data;
        response.data.map((item, idx) => {
          products.push(item);
        });
        this.setState({data: products});
      }
    });
  }

  render() {
    return (
      <section className="center">
        <div className='hot-products-container'>
          <h2 className='hot-products-title'>Sản phẩm bán chạy</h2>
          <div className='hot-products'>
            {
              this.state.data.map((item, i) => {
                return (
                  <div key={i}>
                    <Product
                      enableSendRequest={false}
                      enableAddProduct={true}
                      {...item}/>
                  </div>
                );
              })
            }
          </div>
        </div>
      </section>
    );
  }
}

export default HotProducts;



// WEBPACK FOOTER //
// ./components/home/sub-view/HotProducts.jsx